import type { HomeListingDetails } from './home';

export function Images(this: HomeListingDetails): string[] {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- this.listing() can be undefined if the component is not yet initialized.
  if (!this.listing()) {
    return [];
  }

  const _images =
    this.listing().images ??
    (this.listing().primaryImage ? [this.listing().primaryImage] : undefined) ??
    [];

  if (this.listing().mapImage) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- this.listing().mapImage is checked above, so it cannot be null or undefined here.
    return [..._images, this.listing().mapImage!];
  }

  return _images;
}
